/**
 * 弹窗队列
 */

export class AsyncQueue {
    constructor() {
        this.queue = [];
        this.currentPageNeedSpecialTask = false; // 当前页面是否包含特殊弹窗（除公共弹窗外，仅在当前页面初始化时弹窗）
        this.currentPageSpecialTaskIsEnd = false; // 当前页面特殊弹窗是否执行完毕
        this.isProcessing = false;
        AsyncQueue.instance = null;
    }

    static getInstance() {
        if (!AsyncQueue.instance) {
            AsyncQueue.instance = new AsyncQueue();
        }
        return AsyncQueue.instance;
    }

    push(task) {
        this.queue.push(task);
    }

    unshift(task) {
        this.queue.unshift(task);
    }

    async processQueue() {
        if (this.isProcessing || this.queue.length === 0) {
            return;
        }
        this.isProcessing = true;
        const task = this.queue.shift();
        try {
            await task();
        }
        catch (e) {
            // 错误上报
            console.error(e);
        };
        this.isProcessing = false;
    }

    clear() {
        this.queue = [];
    }

    size() {
        return this.queue.length;
    }
}